import { IndicesPanel } from './IndicesPanel';
import { ObservationsPanel } from './ObservationsPanel';
import type { DmScanDetail } from './types';

export interface ScanSidePanelProps {
    detail: DmScanDetail | null | undefined;
    showIndices: boolean;
    showObservations: boolean;
}

function ScanSidePanel({ detail, showIndices, showObservations }: ScanSidePanelProps) {
    return (
        <>
            {showIndices && <IndicesPanel measurements={detail?.measurements ?? null} />}
            {showObservations && <ObservationsPanel observations={detail?.observations ?? []} />}
        </>
    );
}

export { ScanSidePanel };
